import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Components
import { HomeLayoutComponent } from './home-layout.component';
import { HomeComponent } from './home/home.component';
import { HotelDetailsComponent } from './hotel/hotel-details/hotel-details.component';
import { BrandDevelopmentComponent } from './pages/brand-development/brand-development.component';
import { BrandAdvantageComponent } from './pages/brand-advantage/brand-advantage.component';
import { MeetingEventsComponent } from './pages/meeting-events/meeting-events.component';
import { FaqsComponent } from './pages/faqs/faqs.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';

import { LoyaltyRegisterComponent } from './loyalty/loyalty-register/loyalty-register.component';
import { UserLoginComponent } from './loyalty/user-login/user-login.component';
import { ForgotPasswordComponent } from './loyalty/forgot-password/forgot-password.component';
import { VerifyUserComponent } from './loyalty/verify-user/verify-user.component';
import { AuthGuard } from './loyalty/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: HomeLayoutComponent,
    children: [
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'hotel/:hotelId', component: HotelDetailsComponent, pathMatch: 'full' },
      { path: 'development', component: BrandDevelopmentComponent, pathMatch: 'full' },
      { path: 'advantage', component: BrandAdvantageComponent, pathMatch: 'full' },
      { path: 'faqs', component: FaqsComponent, pathMatch: 'full' },
      { path: 'meeting-events', component: MeetingEventsComponent, pathMatch: 'full' },
      { path: 'privacy-policy', component: PrivacyPolicyComponent, pathMatch: 'full' },
      {
        path: 'login',
        component: UserLoginComponent,
        pathMatch: 'full',
      },
      {
        path: 'register',
        component: LoyaltyRegisterComponent,
        pathMatch: 'full',
      },
      {
        path: 'verify-user',
        component: VerifyUserComponent,
        pathMatch: 'full',
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        pathMatch: 'full',
      },
      {
        path: 'loyalty',
        loadChildren: () =>
          import('./loyalty/loyalty.module').then((m) => m.LoyaltyModule),
        canActivate: [AuthGuard],
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeLayoutRoutingModule { }
